
import { defineComponent, SetupContext, PropType, ref, computed, ComponentPublicInstance, onMounted } from "vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "FridgeDetailsSelectButtons",
  props: {
    /** 選択中 */
    select: {
      type: Number,
      default: 0
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("FridgeDetailsSelectButtons setup start");
    // 表示更新のためのリアクティブ
    const updateDisplayKey = ref(0);
    const updateDisplay = () => {
      if (updateDisplayKey.value == 100) {
        updateDisplayKey.value = 0;
      } else {
        updateDisplayKey.value++;
      }
    };

    // 設定値
    const selectButtonIndex = ref(props.select);

    // ボタンの文言
    const leftButtonTitle = "日";
    const rightButtonTitle = "週";

    // 選択／日選択時のボタン
    const styleLeft = computed(() => {
      if (selectButtonIndex.value == 0) {
        //updateDisplay();
        return { 'background-color': '#ffffff' };
      }
      //updateDisplay();
      return { 'background-color': 'transparent'}
    });
    const styleRight = computed(() => {
      if (selectButtonIndex.value == 1) {
        return { 'background-color': '#ffffff' };
      }
      return { 'background-color': 'transparent'}
    });

    //
    // ボタンの処理
    //
    const leftClick = () => {
      NativeClient.sendDebugLog("FridgeDetailsSelectButtons leftClick");
      if (selectButtonIndex.value == 0) {
        return;
      }
      NativeClient.sendDebugLog("FridgeDetailsSelectButtons leftClick change");
      selectButtonIndex.value = 0;
      context.emit("select-daily");
    };
    const rightClick = () => {
      NativeClient.sendDebugLog("FridgeDetailsSelectButtons rightClick");
      if (selectButtonIndex.value == 1) {
        return;
      }
      NativeClient.sendDebugLog("FridgeDetailsSelectButtons rightClick change");
      selectButtonIndex.value = 1;
      context.emit("select-weekly");
    };

    return {
      updateDisplayKey,
      leftButtonTitle,
      rightButtonTitle,
      styleLeft,
      styleRight,
      leftClick,
      rightClick
    };
  }
});
